/**
 * Props for a Next `Link` (or a `Card component={Link}`) to an in-app route.
 *
 * The app runs with no Next `basePath`, so the router must get the BARE route as `href` and the
 * mount-prefixed URL as `as`. Handing it `${basePath}/route` as `href` makes it resolve a page that
 * does not exist on the `/orion-web` and `/symphony-web` mounts. Returned as a record because
 * `CardProps` declares neither prop, though the `Link` it renders takes both.
 */
export function routeLink(basePath: string, route: string): Record<string, string> {
  return { href: route, as: `${basePath}${route}` };
}
